<template>
	<div class="modal modal--domain modal-domain">
		<div class="modal__loading" v-if="isLoading">
			<loading-spinner />
		</div>
		<div class="modal-domain__form">
			<form-domain :domain="domain" />
		</div>
	</div>
</template>

<script>
import AButton from '@/components/AButton'
import LoadingSpinner from '@/components/LoadingSpinner'
import FormDomain from '@/components/FormDomain.vue'

export default {
	name: 'ModalDomain',
	components: {
		AButton,
		FormDomain,
		LoadingSpinner,
	},
	data: () => ({
		isLoading: false,
	}),
	async mounted() {
		this.loading = true
		if (this.$route.params.domainId) {
			await this.$store.dispatch('blacklist/get', this.$route.params.domainId)
		}
		this.loading = false
	},
	destroyed() {
		this.$store.dispatch('blacklist/unset')
	},
	computed: {
		domain() {
			return this.$store.getters['blacklist/domain']
		},
	},
	metaInfo: () => ({
		title: `Domain Editor`,
	}),

}
</script>

<style scoped lang="scss">
</style>
